import _ from "lodash"

export default {

  namespaced : true,
  
  state : {
    lead  : null,
    broker: null,
  },

  mutations: {

    setLead(state, lead) {
      state.lead = lead;
    },

    setBroker(state, broker) {
      state.broker = broker;
    },
  },
}